<template>
  <v-btn
    block
    :color="color"
    :disabled="disabled"
    :loading="loading"
    class="rounded-lg text-none"
    :class="darkText ? 'black--text' : 'white--text'"
    @click="emitClick"
  >
    <slot></slot>
  </v-btn>
</template>
<script lang="ts">
import { powerTripDarkBlue } from "@/logic/data/const";
import Vue from "vue";

export default Vue.extend({
  name: "ElevatedBlockBtn",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: powerTripDarkBlue,
    },
    darkText: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitClick() {
      this.$emit("click");
    },
  },
});
</script>
